<template>
    <div>
        <!-- <div>
            选择课程 : &nbsp;&nbsp;&nbsp;&nbsp;
            <el-select v-model="courseValue" placeholder="请选择" size="small">
                <el-option v-for="item in courseOption" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div> -->
        <div>
            <el-table :data="data">
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="name" label="实验项目"></el-table-column>
                <el-table-column prop="" label="报告模版">-</el-table-column>
                <el-table-column prop="" label="总数量" width="70">-</el-table-column>
                <el-table-column prop="" label="已提交" width="70">-</el-table-column>
                <el-table-column prop="" label="已批阅" width="70">-</el-table-column>
                <el-table-column prop="" label="待批阅" width="70">-</el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="handSubmit(scope.row)" size="mini">进入批阅</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    methods:{
        handSubmit(data){
            this.$emit('handleStartMark',data)
        }
    },
    props:{
        data:{
            type: Array,
            default:() => {
                return []
            }
        }
    },
}
</script>